import React, { createContext, useContext, useState, useEffect } from 'react';
import SessionContext from "SessionContext";

// create a context for the global state
const GlobalStateContext = createContext();

// create a provider component that will hold the global state
export function GlobalStateProvider({ children }) {
  const session = useContext(SessionContext);
  const [isGlobalStateSaved, setIsGlobalStateSaved] = useState(true);
  const [companyHasExternalDestinations, setCompanyHasExternalDestinations] = useState(false);

  function checkIfCompanyHasDestinationsOn(companyId) {
      if (companyId) {
        session.query("companies/get", { id: companyId }).then(
          (response)=> {
            let _options = response.delivery_options;
            /* check if it has external destinations set as delivery option */
            const hasId4 = _options.some(option => option.id === 4);
            setCompanyHasExternalDestinations(hasId4);
          })
          .catch((err) => {
            console.log("error", err)
          })
      }
    }

  useEffect(() => {
    let _activeCompany = JSON.parse(localStorage.getItem("am:audience:active:company"));
    if(_activeCompany) {
      checkIfCompanyHasDestinationsOn(_activeCompany.id);
    }
  // eslint-disable-next-line
  }, [session.appState.activeCompany])

  return (
    <GlobalStateContext.Provider value={{ 
      isGlobalStateSaved, setIsGlobalStateSaved,
      companyHasExternalDestinations
    }}>
      {children}
    </GlobalStateContext.Provider>
  );
}

// create a custom hook to use the global state
export function useGlobalState() {
  const context = useContext(GlobalStateContext);
  if (!context) {
    console.log("Error: useGlobalState must be used within a GlobalStateProvider")
  }
  return context;
}
